module.exports = __webpack_public_path__ + "static/img_1403-cd80193a2f7acac1f2ec2db3b75174fe.webp";